import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';

import PagesHeroSection from '../../components/pagesHeroSection/pagesHeroSection';
import SEOUpdater from '../../utils/hoc/SEOUpdater';
import TeamCard from '../../components/teamCard';
import { teamMembersKeys } from '../../components/teamCard/mock';

import img2 from '../../assets/homePage/teh2.jpg';
import './teampage.scss';

const TeamPage = () => {
  const { t, i18n } = useTranslation('teamPage');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Translate team member info
  const teamTranslated = teamMembersKeys.map(member => ({
    id: member.id,
    name: t(`teamMembers.${member.key}.name`),
    role: t(`teamMembers.${member.key}.role`),
    bio: t(`teamMembers.${member.key}.bio`),
    imgSrc: member.imgSrc,
    imgClass: member.imgClass,
  }));

  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@graph': teamTranslated.map(member => ({
        '@type': 'Person',
        name: member.name,
        jobTitle: member.role,
        worksFor: { '@id': 'https://avagyanlaw.com/#organization' },
        ...(member.bio && { description: member.bio }),
      })),
    };

    let script = document.querySelector('script[data-structured-data="team"]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-structured-data', 'team');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);

    return () => {
      script.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  return (
    <div className="teampage">
      {/* Dynamic SEO metadata */}
      <SEOUpdater page="teamPage" />

      {/* Hero Section */}
      <PagesHeroSection page={t('pageTitle')} />

      <Container>
        <section className="about-section">
          {/* Team Cards */}
          <Row className="mb-5 team-card-wrap">
            {teamTranslated.map(member => (
              <Col sm={12} lg={6} xl={4} key={member.id}>
                <TeamCard
                  imageSrc={member.imgSrc}
                  name={member.name}
                  role={member.role}
                  bio={member.bio}
                  imgClass={member.imgClass}
                />
              </Col>
            ))}
          </Row>

          {/* About the Lead Attorney */}
          <Row className="align-items-center flex-row-reverse">
            <Col lg={6} className="text-center mb-4 mb-lg-0">
              <img
                src={img2}
                alt="Attorney"
                className="about-image img-fluid rounded"
                width={1080}
                height={1616}
              />
            </Col>
            <Col lg={6}>
              <h2 className="about-title">{t('meetAttorneyTitle')}</h2>
              <p className="about-text">{t('meetAttorneyParagraph1')}</p>
              <p className="about-text">{t('meetAttorneyParagraph2')}</p>
              <p className="about-text">{t('meetAttorneyParagraph3')}</p>
            </Col>
          </Row>
        </section>
      </Container>
    </div>
  );
};

export default TeamPage;
